import { createContext } from 'react';
import utils from 'utils';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';

type FileDownloadContextProps = {
  openDownloadModal: (
    dataRoomId: string,
    nodes?: DataRoomNode[],
    baseLevelNodes?: DataRoomNode[],
  ) => void;
};

export default createContext<FileDownloadContextProps>({
  openDownloadModal: utils.noop,
});
